import { useEsquemaCalendarioVacinalQuery } from 'graphql/hooks.generated'
import { GrupoAlvoVacinacaoEnum } from 'graphql/types.generated'
import React from 'react'
import { convertEsquemaCalendarioVacinalQueryToProps } from 'view/atendimentos/atendimento-vacinacao/condicoes/converter'
import { CidadaoAtendimento } from 'view/atendimentos/types/CidadaoAtendimento'

import { VacinacaoPanel } from '../components/vacinacao/VacinacaoPanel'
import { EstadoBotaoCalendario } from './VacinacaoView'

interface VacinacaoCalendarioViewProps {
  cidadao: CidadaoAtendimento
  gestante: boolean
  dataAtendimento: Instant
  estadoBotaoCalendario: EstadoBotaoCalendario
  grupoAlvoCidadao: GrupoAlvoVacinacaoEnum
}

export function VacinacaoCalendarioView(props: VacinacaoCalendarioViewProps) {
  const { cidadao, gestante, dataAtendimento, estadoBotaoCalendario, grupoAlvoCidadao } = props

  const { data } = useEsquemaCalendarioVacinalQuery({
    variables: {
      input: {
        sexo: cidadao.sexo,
        grupoAlvo: grupoAlvoCidadao,
        gestante: gestante,
      },
    },
    fetchPolicy: 'cache-first',
  })

  const calendarioVacinalProps = convertEsquemaCalendarioVacinalQueryToProps(data, cidadao, dataAtendimento)

  return (
    <>
      {estadoBotaoCalendario === 'CALENDARIO_VACINAL' ? (
        <VacinacaoPanel imunobiologicos={calendarioVacinalProps} />
      ) : (
        <VacinacaoPanel imunobiologicos={[]} outrosImunobiologicos />
      )}
    </>
  )
}
